import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  RESET_CHANGE_PASSWORD_STATUS,
  RESET_CHANGE_PASSWORD_ERROR,
} from "./actionTypes";

export const changePassword = (user) => {
  return {
    type: CHANGE_PASSWORD,
    payload: { user },
  };
};

export const changePasswordSuccess = (user) => {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    payload: user,
  };
};

export const changePasswordError = (error) => {
  return {
    type: CHANGE_PASSWORD_ERROR,
    payload: error,
  };
};

export const resetChangePasswordStatus = () => {
  return {
    type: RESET_CHANGE_PASSWORD_STATUS,
  };
};

export const resetChangePasswordError = () => {
  return {
    type: RESET_CHANGE_PASSWORD_ERROR,
  };
};
